<template>
  <div class="apply-step apply-step--terminal">
    <div class="apply-step__icon">⏳</div>
    <h2>¡Recibimos tu video y tus documentos!</h2>
    <p>Nuestro equipo revisará tu postulación en los próximos 1-3 días hábiles.</p>
    <p>Te confirmaremos el resultado por WhatsApp al celular que registraste.</p>
    <p class="apply-step__hint mt-3">Puedes cerrar esta página tranquilamente.</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Step11Pending',
  mounted() {
    this.clearAll()
  },
  methods: { ...mapActions('apply', ['clearAll']) },
}
</script>

<style src="../apply-step.css" scoped></style>
<style scoped>
.apply-step--terminal { text-align: center; padding: 2rem 1rem; }
.apply-step__icon { font-size: 4rem; margin-bottom: 1rem; }
</style>
